import { keyframes } from 'styled-components'

export default keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: none;
  }
`



// WEBPACK FOOTER //
// ./src/animations/fadeInUp.js